import React from "react";
import Countdown from 'react-countdown';
import Nav from "./Nav.js";

import logo from './logo.svg';
import './App.css';

function App() {

  /*ReactDOM.render(
    <Countdown date={Date.now() + 10000} />,
    document.getElementById('root')
  
  #6d0020
  #470015
  #910ca8

    bg-gradient-to-b from-gray-500 to-a2c-orange
  );*/

  return (
    <div className="App">
      <div className="length-h-screen">
        <header className="App-header bg-[url('college_campus.jpg')] flex flex-col">
          <p className="labelText font-bold text-9xl text-center mt-24">AETEAU COLLEGE</p>
          <p className="labelText font-bold text-4xl text-center mt-12">Your future home.</p>
        </header>
      </div>
      <div className="pb-36 bg-white">
        <p className="font-bold text-black text-6xl mt-32 ml-24 italic">Nos nescio quomodo latine loqui.</p>
        <p className="text-gray-700 text-2xl mt-16 text-right mr-24 ml-[40%] italic">When our noble founder, John Aeteau, founded Aeteau College, he desired to bring the hell of the college application process to all. Now, over one year since its founding, we're bringing that ideal to everyone. At Aeteau, everyone can be an Applying-to-College tryhard who doesn't touch grass.</p>
      </div>
      <div className="bg-a2c-green pt-32 pb-32">
        <p className="labelText font-bold text-5xl text-white text-center">Learn about Aeteau's application process:</p>
        <div className="grid grid-cols-3 mx-80 gap-12 mt-12">
          <button className="bg-gray-200 hover:bg-gray-300 rounded-xl px-5 py-3">Admissions</button>
          <button className="bg-gray-200 hover:bg-gray-300 rounded-xl px-5 py-3">Application Requirements</button>
          <button className="bg-gray-200 hover:bg-gray-300 rounded-xl px-5 py-3">Decision</button>
        </div>
      </div>
    </div>
  );
}

export default App;
